export const SET_PORTFOLIOS = "SET_PORTFOLIOS";
export const SET_ACTIVE_PORTFOLIO_ID = "SET_ACTIVE_PORTFOLIO_ID";
export const SET_PORTFOLIO = "SET_PORTFOLIO";
export const RESET_PORTFOLIO_DATA = "RESET_PORTFOLIO_DATA";
export const SET_PORTFOLIO_DATA = "SET_PORTFOLIO_DATA";
export const SET_REPORT_DATA = "SET_REPORT_DATA";
export const SET_PORTFOLIO_CHART = "SET_PORTFOLIO_CHART";
export const SET_PORTFOLIO_SHARED_WITH_ME = "SET_PORTFOLIO_SHARED_WITH_ME";
export const SET_SHARED_PORTTFOLIO_COLLABORATOR = "SET_SHARED_PORTTFOLIO_COLLABORATOR";
